class MultipleCollections extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      options: this.querySelectorAll(".select_collection"),
      collections: this.querySelectorAll(".collection__item"),
    };

    this.init();
  }

  init() {
    const paramsURL = new URLSearchParams(window.location.search);
    const utm_gender = paramsURL.get("utm_gender");
    const utm_content = paramsURL.get("utm_content");
    let matchFound = false;

    const utm_match = utm_gender || utm_content;

    if (utm_match && this.elements.options.length > 1) {
      matchFound = [...this.elements.options].some((o) => o.dataset.content == utm_match);
    }

    if (matchFound) {
      [this.elements.options, this.elements.collections].forEach((list) => {
        list.forEach((el) => el.classList.toggle("active", el.dataset.content == utm_match));
      });
    }

    this.elements.options.forEach((option) => {
      option.addEventListener("click", this.handleOptionChange.bind(this));
    });
  }

  handleOptionChange(event) {
    this.elements.options.forEach((option) => {
      option.classList.remove("active");
    });

    let selection =
      Array.from(event.target.classList).find((elements) => elements === "select_collection") == undefined
        ? event.target.parentElement
        : event.target;

    selection.classList.add("active");

    let value = selection.dataset.index;

    this.elements.collections.forEach((collection) => {
      collection.classList.remove("active");
      if (collection.dataset.index == value) {
        Array.from(collection.classList).find((item) => item == "active") == undefined
          ? collection.classList.add("active")
          : collection.classList.remove("active");
      }
    });
  }
}

customElements.define("multiple-collections", MultipleCollections);